'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarouselBrowserify = require('slick-carousel-browserify');

var _slickCarouselBrowserify2 = _interopRequireDefault(_slickCarouselBrowserify);

var _award = require('../molecules/award.vue');

var _award2 = _interopRequireDefault(_award);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'award': _award2.default
    },
    props: ['awards'],
    ready: function ready() {
        var self = this;

        var $awards_slider = (0, _jquery2.default)('.awards-slider');

        $awards_slider.slick({
            dots: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            variableHeight: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }, {
                breakpoint: 530,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '44px',
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 375,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '44px',
                    slidesToShow: 1
                }
            }]
        });

        //          we should close the toggle if
        $awards_slider.on('swipe', function (event, slick, direction) {
            self.$broadcast('close_details');
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<ul class=\"awards-slider\">\n   <li v-for=\"award of awards\" class=\"awards-slider__item\">\n       <award :award=\"award\">\n       </award>\n   </li>\n</ul>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1023c006", module.exports)
  } else {
    hotAPI.update("_v-1023c006", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}